import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { MessageOutlined } from '@ant-design/icons';
import { Descriptions, Divider, Drawer, Table, Tooltip, Col, Tag, Typography } from 'antd';
import moment from "moment";
import { When } from "react-if";
import { useMediaQuery } from 'usehooks-ts';

import { RootState } from "../../store";
import { ChatService } from "../../services/chat.service";
import { leadService } from "../../services/lead.service";
import { AttendanceTypes } from "../../types/attendance.types";
import { ModalChatViewer } from "../modal-chat-viewer";
import { RegexFactory } from "../../factory/regex.factory";

export const LeadDetailsDrawer = () => {
    const isSmallScreen = useMediaQuery('(max-width: 768px)');

    const { modal, selectedLeadId } = useSelector((state: RootState) => state.chat);
    const { lead, leadAttendancesPagination, loading } = useSelector((state: RootState) => state.lead);
    const [selectedAttendance, setSelectedAttendance] = useState<AttendanceTypes.Model>({} as AttendanceTypes.Model);
    const [viewChatModalVisible, setViewChatModalVisible] = useState(false);

    const [pagination, setPagination] = useState({
        page: 1,
        perPage: 10,
    });

    const onClose = () => {
        ChatService.dispatch.setSelectedLeadId(0);
        ChatService.dispatch.toggleModal('leadDetails', false);
    }

    const onChangePagination = (page: number, perPage: number) => {
        setPagination({ page, perPage });
    }

    useEffect(() => {
        if (selectedLeadId > 0 && modal.leadDetails) {
            leadService.getById(selectedLeadId, (isValid, msg) => {});
        }
    }, [modal.leadDetails, selectedLeadId]);

    useEffect(() => {
        if (selectedLeadId > 0 && modal.leadDetails) {
            leadService.fetchAttendancesByLead({ ...pagination, filter: {} as AttendanceTypes.Filters }, selectedLeadId, (isValid, msg) => {});
        }
    }, [modal.leadDetails, selectedLeadId, pagination]);

    return (
        <>
            <Drawer
                title={'Detalhes do Lead'}
                placement={'right'}
                open={modal.leadDetails}
                onClose={onClose}
                width={isSmallScreen ? '90vw' : 750}
            >
                <Descriptions column={2} size='default' layout='vertical'>
                    <Descriptions.Item span={1} label="Nome" labelStyle={{ fontWeight: 600 }}>
                        {lead?.name}
                    </Descriptions.Item>
                    <Descriptions.Item label="WhatsApp" labelStyle={{ fontWeight: 600 }}>
                        {RegexFactory.phoneNumber(lead?.contact)}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label="Data de criação" labelStyle={{ fontWeight: 600 }}>
                        {moment(lead?.createdAt).format('DD/MM/YYYY hh:mm')}
                    </Descriptions.Item>
                    <Descriptions.Item span={1} label="Última atualização" labelStyle={{ fontWeight: 600 }}>
                        {moment(lead?.updatedAt).format('DD/MM/YYYY hh:mm')}
                    </Descriptions.Item>
                </Descriptions>
                <div style={{flexDirection: 'column'}}>
                    <Typography.Text> Tags: </Typography.Text> <br/> <br/>
                    {
                        lead.tags?.map(e => 
                            <Tag color="#21B573">{e.name}</Tag>
                        )
                    } 

                </div>
                <Descriptions title="Atendimentos" style={{ marginTop: 15, marginBottom: -10 }}></Descriptions>
                <div className="table-responsive">
                    <Table 
                        columns={[
                            {
                                title: 'Protocolo',
                                render: (_, att) => <strong># {att.protocol}</strong> 
                            },
                            {
                                title: 'Atendente',
                                render: (_, att) => <>{att?.user?.name}</> 
                            },
                            {
                                title: 'Status',
                                render: (_, att) => 
                                <Tag 
                                    className={
                                        att?.status === AttendanceTypes.Status.STARTED ? 
                                        'bg-warning-lightest' : 'bg-success-lightest'
                                    } 
                                    color={att?.status === AttendanceTypes.Status.STARTED ? 'yellow' : 'green'}>
                                    <span className="font-weight-semibold">
                                        {att?.status === AttendanceTypes.Status.STARTED  ? 'Em Atendimento' : 'Concluído'}
                                    </span>
                                </Tag>
                            },
                            {
                                title: 'Iniciado em',
                                dataIndex: 'createdAt',
                                render: (_, att) => moment(att.createdAt).format('DD/MM/YYYY HH:mm')
                            },
                            {
                                title: 'Ações',
                                dataIndex: 'actions',
                                render: (_, att) => (
                                    <div className="text-center"> 
                                        <Tooltip placement="topLeft" title="Visualizar atendimento">
                                            <MessageOutlined 
                                                size={48}
                                                onClick={() => {
                                                    setSelectedAttendance(att);
                                                    setViewChatModalVisible(true);
                                                }}
                                            />
                                        </Tooltip>
                                    </div>
                                )
                            }
                        ]} 
                        locale={{
                            emptyText: <Col style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                
                                <span>{'Aparentemente este atendente não possui nenhum atendimento.'}</span>
                            </Col>,
                            
                        }}
                        loading={loading.fetchAttendancesByLead}
                        dataSource={leadAttendancesPagination?.items} 
                        pagination={{
                            pageSize: pagination.perPage,
                            total: leadAttendancesPagination?.total,
                            defaultCurrent: 1,
                            onChange: onChangePagination
                        }}
                    />
                </div>
            </Drawer>
            <When condition={viewChatModalVisible}>
                <ModalChatViewer 
                    selectedAttendance={selectedAttendance}
                    visible={viewChatModalVisible}
                    onClose={() => {
                        setSelectedAttendance({} as AttendanceTypes.Model);
                        setViewChatModalVisible(false);
                    }}
                />
            </When>
        </>
    )
}